<template>
  <p class="campaign-backup-explanation text-center">
    {{explanation}}
  </p>
</template>


<script>
  export default {
    props: {
      backupType: String,
    },

    name: 'CampaignBackupExplanation',

    data() {
      return {
        endText: " below, depending on which they are most likely to receive, as well as any digital coupon, product link, or any link configured above",
        startText: "if any of your customers have your ",
      }
    },

    computed: {
      explanation: function () {
        const mainType = this.backupType === 'mms' ? 'sms' : 'mms',
          text = `${mainType} campaign filtered by carriers, we’ll send them the ${this.backupType}`
        return this.startText + text + this.endText
      },
    },
  }
</script>